import React, { useState } from "react";
import start_rating from "../../assets/images/start_rating.webp";
import tuanle_mo from "../../assets/images/tuanle_mo.webp";
import tuanle_pc from "../../assets/images/tuanle_pc.webp";
import { FiMapPin } from "react-icons/fi";

import leftt from "../../assets/images/leftt.svg";
import rightt from "../../assets/images/rightt.svg";
import pc_01 from "../../assets/images/pc_01.webp";
import mobi01 from "../../assets/images/mobi01.webp";
import pc02 from "../../assets/images/pc02.webp";
import mobi02 from "../../assets/images/mobi02.webp";
import pc03 from "../../assets/images/pc03.webp";
import mobi03 from "../../assets/images/mobi03.webp";
import mobi04 from "../../assets/images/mobi04.webp";
import pc04 from "../../assets/images/pc04.webp";
import mobi05 from "../../assets/images/mobi05.webp";
import pc05 from "../../assets/images/pc05.webp";
import mobi06 from "../../assets/images/mobi06.webp";
import pc06 from "../../assets/images/pc06.webp";
import mobi07 from "../../assets/images/mobi07.webp";
import pc07 from "../../assets/images/pc07.webp";
import mobi08 from "../../assets/images/mobi08.webp";
import pc08 from "../../assets/images/pc08.webp";
import mobi09 from "../../assets/images/mobi09.webp";
import pc09 from "../../assets/images/pc09.webp";
import mobi10 from "../../assets/images/mobi10.webp";
import pc10 from "../../assets/images/pc10.webp";
import mobi11 from "../../assets/images/mobi11.webp";
import pc11 from "../../assets/images/pc11.webp";
import mobi12 from "../../assets/images/mobi12.webp";
import pc12 from "../../assets/images/pc12.webp";
import mobi13 from "../../assets/images/mobi13.webp";
import pc13 from "../../assets/images/pc13.webp";
import mobi14 from "../../assets/images/mobi14.webp";
import pc14 from "../../assets/images/pc14.webp";
import mobi15 from "../../assets/images/mobi15.webp";
import pc15 from "../../assets/images/pc15.webp";
import mobi16 from "../../assets/images/mobi16.webp";
import pc16 from "../../assets/images/pc16.webp";
import mobi17 from "../../assets/images/mobi17.webp";
import pc17 from "../../assets/images/pc17.webp";
import mobi18 from "../../assets/images/mobi18.webp";
import pc18 from "../../assets/images/pc18.webp";

const testimonials = [
  {
    text: "Dịch vụ phần mềm tuyệt vời",
    content:
      "Phần mềm quản lý giáo dục của công ty Bầu Trời Xanh đã giúp chúng tôi tối ưu hóa quy trình dạy học và quản lý học viên một cách hiệu quả. Nhờ đó, chúng tôi có thể tập trung hơn vào chất lượng giảng dạy và tăng cường sự hài lòng của phụ huynh và học sinh.",
    name: "Lê Quang Huy",
    position: "Giám đốc trung tâm Anh Ngữ- HuyLe",
    location: "Đan Phượng - Hà Nội",
    imageMobile: tuanle_mo,
    imageDesktop: tuanle_pc,
  },
  {
    text: "Tiết kiệm được khá nhiều thời gian làm việc",
    content:
      "Dịch vụ tích hợp hệ thống của Bầu Trời Xanh rất chuyên nghiệp. Họ giúp chúng tôi kết nối các hệ thống công nghệ cũ với những nền tảng một cách trơn tru, giảm thiểu thời gian gián đoạn và đảm bảo an ninh dữ liệu",
    name: "Vũ Hồng Quyền",
    position: "Trưởng phòng kỹ thuật-Keyavo",
    location: "Thanh Xuân - Hà Nội",
    imageMobile: mobi01,
    imageDesktop: pc_01,
  },
  {
    text: "Hệ thống quản lý dễ dàng",
    content:
      "Chúng tôi rất hài lòng với các giải pháp công nghệ mà Bầu Trời Xanh cung cấp. Hệ thống theo dõi và quản lý quy trình sản xuất nông sản của chúng tôi đã trở nên mình bạch và dễ dàng hơn bao giờ hết, đồng thời giúp đáp ứng các tiêu chuẩn an toàn vệ sinh thực phẩm",
    name: "Trần Văn Bạch",
    position: "Chủ trang trại nông nghiệp sạch",
    location: "Đà Lạt - Lâm Đồng",
    imageMobile: mobi02,
    imageDesktop: pc02,
  },
  {
    text: "Giải pháp phát triển toàn diện",
    content:
      "Bầu Trời Xanh cung cấp một giải pháp phát triển web và di động toàn diện. Nhóm phát triển đã giúp chúng tôi xây dựng ứng dụng Android và IOS hoàn hảo, từ thiết kế đến triển khai, với sự hỗ trợ kỹ thuật 24/7 cực kỳ hiệu qủa",
    name: "Vũ Hoàng Nam",
    position: "Nhà phát triển ứng dụng di động",
    location: "Cầu Giấy - Hà Nội",
    imageMobile: mobi03,
    imageDesktop: pc03,
  },
  {
    text: "Tối ưu vận hành",
    content:
      "BlueSkyIT có đội ngũ hỗ trợ vô cùng tận tình. Sản phẩm của họ giúp tối ưu hóa hoạt động cho trung tâm giáo dục của chúng tôi và nâng cao trải nghiệm học tập cho học sinh.",
    name: "Nguyễn Thanh Tùng",
    position: "Giám đốc trung tâm giáo dục",
    location: "Hà Đông, Hà Nội",
    imageMobile: mobi04,
    imageDesktop: pc04,
  },
  {
    text: "Sản phẩm tuyệt vời",
    content:
      "Tôi đã sử dụng sản phẩm dầu bơ ép lạnh Keyavo và thấy làn da mềm mại, mịn màng hơn hẳn. Đặc biệt là không hề bị nhờn dính. Cảm ơn BlueSkyIT đã mang đến một sản phẩm tuyệt vời",
    name: "Nguyễn Thị Thanh Mai",
    position: "Nhân viên văn phòng",
    location: "Long Biên - Hà Nội",
    imageMobile: mobi05,
    imageDesktop: pc05,
  },
  {
    text: "Phần mềm cực kỳ tiện dụng",
    content:
      "Hệ thống quản trị giáo dục Blue Rise rất trực quan và dễ sử dụng, giúp tôi quản lý lớp học và tương tác với phụ huynh một cách thuận tiện hơn. Tôi thực sự hài lòng với sự hỗ trợ tận tình từ đội ngũ BlueSkyIT.",
    name: "Trần Quốc Đạt",
    position: "Giám Đốc",
    location: "Đống Đa - Hà Nội",
    imageMobile: mobi06,
    imageDesktop: pc06,
  },
  {
    text: "Sản phẩm thiên nhiên, an toàn",
    content:
      "Sản phẩm Keyavo giúp tôi giữ được hương vị tự nhiên cho các món salad mà tôi yêu thích. Mùi vị rất dễ chịu và cảm giác như đang sử dụng sản phẩm từ thiên nhiên vậy",
    name: "Lê Thị Ngọc Hân",
    position: "Kinh doanh thời trang",
    location: "Hoàng Mai - Hà Nội",
    imageMobile: mobi07,
    imageDesktop: pc07,
  },
  {
    text: "Tối ưu vận hành",
    content:
      "Blue Rise giúp trung tâm của tôi tối ưu hóa hoạt động tuyển sinh, thu hút thêm nhiều học sinh. Thật tiện lợi khi tất cả đều được quản lý trong một hệ thống",
    name: "Phạm Văn Hùng",
    position: "Trưởng phòng kinh doanh",
    location: "Cầu Giấy - Hà Nội",
    imageMobile: mobi08,
    imageDesktop: pc08,
  },
  {
    text: "Sản phẩm tuyệt vời",
    content:
      "Dầu bơ Keyavo mang đến cảm giác mịn màng, không nhờn và thẩm thấu nhanh. Tôi tin dùng cho làn da mỗi ngày và thấy thật sự hiệu quả",
    name: "Ngô Thanh Tú",
    position: "Nhân viên văn phòng",
    location: "Thanh Xuân - Hà Nội",
    imageMobile: mobi09,
    imageDesktop: pc09,
  },
  {
    text: "Quản lý công việc nhanh, gọn, hiệu quả",
    content:
      "Blue Rise giúp trung tâm của tôi tối ưu hóa hoạt động tuyển sinh, thu hút thêm nhiều học sinh. Thật tiện lợi khi tất cả đều được quản lý trong một hệ thống",
    name: "Hoàng Thị Minh Anh",
    position: "Giám đốc trung tâm giáo dục",
    location: "Thanh Xuân - Hà Nội",
    imageMobile: mobi10,
    imageDesktop: pc10,
  },
  {
    text: "Sản phẩm tuyệt vời",
    content:
      "Dầu ăn từ bơ ép lạnh của Keyavo thật sự chất lượng và chịu nhiệt cao. Đồ ăn thơm ngon hơn hẳn khi chế biến bằng loại dầu này",
    name: "Nguyễn Văn Khánh",
    position: "Giám đốc trung tâm thể hình",
    location: "Ba Đình, Hà Nội",
    imageMobile: mobi11,
    imageDesktop: pc11,
  },
  {
    text: "Phần mềm cực kỳ tiện dụng",
    content:
      "Hệ thống Blue Rise cho phép tôi quản lý lớp học trên mọi thiết bị. Tôi không còn bị phụ thuộc vào máy tính, giúp tiết kiệm thời gian đáng kể.",
    name: "Lê Quang Trường",
    position: "Quản lý chuyên môn",
    location: "Tây Hồ, Hà Nội",
    imageMobile: mobi12,
    imageDesktop: pc12,
  },
  {
    text: "Hỗ trợ tận tình",
    content:
      "Các sản phẩm của BlueSkyIT luôn đạt chất lượng cao. Đặc biệt là dịch vụ hỗ trợ của họ rất nhanh chóng, giúp tôi giải quyết các vấn đề phát sinh một cách dễ dàng.",
    name: "Phạm Thị Bích",
    position: "Trưởng phòng chuyên môn",
    location: "Hoàn Kiếm, Hà Nội",
    imageMobile: mobi13,
    imageDesktop: pc13,
  },
  {
    text: "Chương trình chất lượng",
    content:
      "Học viện Bigmax Academy của BlueSkyIT có chương trình đào tạo rất chất lượng. Con tôi tiến bộ đáng kể sau khi theo học tại đây.",
    name: "Vũ Hoàng Long",
    position: "Trưởng phòng kinh doanh",
    location: "Thanh Xuân, Hà Nội",
    imageMobile: mobi14,
    imageDesktop: pc14,
  },
  {
    text: "Hỗ trợ tận tình",
    content:
      "Đội ngũ BlueSkyIT rất chuyên nghiệp và tận tâm. Họ luôn lắng nghe ý kiến của khách hàng và cải tiến sản phẩm phù hợp với nhu cầu thực tế.",
    name: "Nguyễn Thu Hà",
    position: "Giám đốc trung tâm giáo dục",
    location: "Long Biên, Hà Nội",
    imageMobile: mobi15,
    imageDesktop: pc15,
  },
  {
    text: "Tối đa lợi ích",
    content:
      "Blue Rise giúp trung tâm của tôi tăng tỷ lệ học sinh quay lại nhờ vào cộng đồng hỏi đáp 24/7. Rất đáng đồng tiền bỏ ra",
    name: "Lâm Đức Hiếu",
    position: "Giám đốc trung tâm giáo dục",
    location: "Hoàng Mai, Hà Nội",
    imageMobile: mobi16,
    imageDesktop: pc16,
  },
  {
    text: "Sản phẩm vì sức khoẻ",
    content:
      "Tôi rất ấn tượng với dầu trộn salad từ bơ Keyavo. Hương vị nguyên bản của salad được giữ trọn vẹn và còn tốt cho sức khỏe",
    name: "Phạm Minh Châu",
    position: "HLV Yoga",
    location: "Cầu Giấy, Hà Nội",
    imageMobile: mobi17,
    imageDesktop: pc17,
  },
  {
    text: "Tiết kiệm thời gian",
    content:
      "Tính năng tuyển sinh và quản lý học viên của Blue Rise rất tối ưu, giúp tôi tiết kiệm rất nhiều thời gian cho công việc. Đội ngũ luôn phản hồi nhanh chóng",
    name: "Đỗ Thị Lan",
    position: "Giám đốc trung tâm giáo dục",
    location: "Hà Đông, Hà Nội",
    imageMobile: mobi18,
    imageDesktop: pc18,
  },
];

export default function FeedBack() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="w-full bg-[#f8ffff]">
      <div className="container w-full mx-auto p-3 flex flex-col gap-4 lg:flex-row lg:gap-3 lg:pt-7">
        <div className="flex flex-col gap-6 w-full shadow-custom1 rounded-[8px] bg-white px-[1.5rem] py-[1rem] h-auto lg:w-3/12 border border-solid border-[#E2E2E2] ">
          <div>
            <p className="text-[#033F6A] font-semibold text-[1.5rem] w-[18.875rem] lg:w-[280px] lg:text-[36px]  ">
              Khách hàng nói gì về{" "}
              <spam className="text-[36px] text-[#27C6FF]">BlueSkyIT</spam>
            </p>
          </div>
          <div className="flex flex-col gap-2">
            <img src={start_rating} alt="st" className="w-[7rem]" />
            <p className="lg:w-[200px]">
              Hơn 200 đánh giá từ khách hàng về chúng tôi
            </p>
          </div>
        </div>
        <div className="w-full lg:w-9/12  shadow-custom1 rounded-[8px] px-[1.88rem]  py-[1.5rem] h-auto border border-solid border-[#E2E2E2] ">
          <div className="flex flex-col gap-3">
            <p className="text-[#27C6FF] text-[1.25rem] font-semibold flex-wrap">
              {testimonials[currentIndex].text}
            </p>
            <p className="text-[1rem] text-[#033F6A] font-normal w-full h-[12rem] lg:h-[4.5rem]  lg:w-full md:w-full">
              {testimonials[currentIndex].content}
            </p>
          </div>
          <div className="lg:flex items-center gap-3">
            <div className="mt-4">
              <img
                src={testimonials[currentIndex].imageMobile}
                alt="tl"
                className="rounded-[8px] w-full block lg:hidden"
              />
              <img
                src={testimonials[currentIndex].imageDesktop}
                alt="tlpc"
                className="w-full hidden lg:block lg:w-[7.25rem] lg-[7.6875rem]"
              />
            </div>
            <div className="flex items-center relative flex-col h-[11rem] lg:flex-row justify-center pt-6 gap-4  w-full">
              <div className="absolute lg:left-0 ">
                <div className="flex flex-col items-center gap-4 lg:items-start justify-center">
                  <p className="text-[#033F6A] text-[1.125rem] font-semibold">
                    {testimonials[currentIndex].name}
                  </p>
                  <p className="lg:whitespace-nowrap text-[#606060] text-[1rem] font-normal ">
                    {testimonials[currentIndex].position}
                  </p>
                </div>

                <div className="flex gap-1 items-center lg:float-start justify-center lg:pt-3">
                  <FiMapPin />
                  <p>{testimonials[currentIndex].location}</p>
                </div>
              </div>

              <div className="flex gap-2 w-full items-center justify-center lg:w-full absolute -bottom-4 lg:bottom-3 lg:left-[360px] ">
                <button
                  className="w-10 h-10 border border-[#E1F7FF] bg-[#E1F7FF] rounded-full flex items-center justify-center"
                  onClick={handlePrev}
                >
                  <img src={leftt} alt="le" />
                </button>
                <button
                  className="w-10 h-10 border border-[#E1F7FF] bg-[#E1F7FF] rounded-full flex items-center justify-center"
                  onClick={handleNext}
                >
                  <img src={rightt} alt="ri" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
